import React, { forwardRef } from 'react';
import styled from 'styled-components';
import IEditableProps from 'src/utilities/IEditableProps';
import IStyledProps from 'src/utilities/IStyledProps';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';

export enum VariantEnum {
   "link",
   "primary",
   "secondary",
   "success",
   "danger",
   "warning",
   "info",
   "dark",
   "light",
   "outline-primary",
   "outline-secondary",
   "outline-success",
   "outline-danger",
   "outline-warning",
   "outline-info",
   "outline-dark",
   "outline-light",
   "outline-white"
}
export interface IButtonProps extends IEditableProps, IStyledProps {
   label: string;
   variant: VariantEnum;
   outline: boolean;
   onFunction;
}

export default styled(forwardRef((props: IButtonProps, ref: any) => {
   const { editorClassObj, className, cmsId, variant, outline } = props;

   return (
      <Button
         type="button"
         data-id={cmsId}
         onClick={handleClick}
         variant={`${outline ? "outline-" : ""}${variant}` as "link" | "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "dark" | "light" | "outline-primary" | "outline-secondary" | "outline-success" | "outline-danger" | "outline-warning" | "outline-info" | "outline-dark" | "outline-light" | "outline-white"}
         ref={ref}
         className={classNames('btn', className, editorClassObj)}>{props.label}</Button>
   )

   function handleClick(e) {
      if(props.onFunction) props.onFunction({
         type: 'set',
         name: 'username',
         value: 'Hello'
      });
   }
}))`

`